import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const Phone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M18.544 16.22l-2.989-2.639-.736.72a.861.861 0 01-1.067.123 13.364 13.364 0 01-4.167-4.146.854.854 0 01.125-1.059l.902-.93L7.22 5 5.318 6.84c-.297.297-.397.74-.252 1.134a18.478 18.478 0 0011.002 10.96c.396.145.84.046 1.139-.251L19 16.63l-.456-.41z"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)
